import React from "react"

import logoSrc from "assets/images/logo.jpg"

export default function Logo(props) {
  return <img src={logoSrc} width={60} height={60} alt="Logo" {...props} />
}
